// extracted by mini-css-extract-plugin
export default {"textSelected":"NavBar_textSelected__7yHG7","selected":"NavBar_selected__aNKmS","grow":"NavBar_grow__tYGWR"};